// component
import TableCard from "../tableCard/TableCard";
import { DeleteIcon } from "../kits/Icons";
import { StepIcon } from "../kits/Icons";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import StepModal from "./StepModal";
import useAxios from "../../services/useAxios";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import ToastCustomize from "../kits/ToastCustomize";
import { TimeStampToJalali } from "../../utils/helperFunction";
import CustomButton from "../kits/button/CustomButton";
import { translateToReactSelect } from "../../utils/helperFunction";
import Loader from "../../utils/Loader";
import { searchFunc } from "../../utils/helperFunction";
import SearchInputContext from "../../Search/SearchInput";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

// style
import "./ClewList.scss";
import ColorSchema from "../kits/Color";
// react
import { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
export default function Clewlist() {
  const { userInfo } = useContext(AuthenticationContext);

  // useAxios
  const { execute: getleads } = useAxios("api2/get_leads");
  const { execute: deleteLeads } = useAxios("test/delete_lead");
  const { execute: getStep } = useAxios("api/Find_step");
  const { execute: changeStep } = useAxios("api2/change_lead_step");

  // state
  const [baseContent, setBaseContent] = useState([]);
  const { searchInput } = useContext(SearchInputContext);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [clewUpdater, setClewUpdater] = useState(false);
  const [content, setContent] = useState([]);
  const [stepModal, setStepModal] = useState([]);
  const [lastStepId, setLastStepId] = useState([]);
  const [header, setHeader] = useState([
    {
      type: "title",
      title: "نام مشتری",
      name: "customerTitle",
    },
    {
      type: "title",
      title: "نام شرکت ",
      name: "company_name",
    },
    {
      type: "title",
      title: "  عنوان کمپین ",
      name: "title",
    },
    {
      type: "description",
      title: " اطلاعات محصول کمپین  ",
      name: "info",
    },
    {
      type: "description",
      title: " زمان شروع کمپین  ",
      name: "starttm",
    },
    {
      type: "description",
      title: " زمان پایان کمپین  ",
      name: "endtm",
    },
    {
      type: "title",
      title: " کاربر اصلی    ",
      name: "fullname",
    },

    {
      type: "operation",
      title: " عملیات ",
      name: "operation",
    },
  ]);
  useEffect(() => {
    if (userInfo.userRoll.includes(12)) {
      let array = header;
      array.push({
        type: "title",
        title: " اخرین استپ    ",
        name: "step",
      });
      setHeader(array);
    }
  }, []);
  const [step, setstep] = useState([]);
  const [info, setInfo] = useState([
    // {
    //   title: "بی عنوان",
    //   description: "توضبحاتی برای اراءه نداریم جیگر",
    //   operator: "من",
    //   resultstep: false,
    //   titleAndDesc: "دتدتا",
    //   descOperator: "حالا هرچی",
    //   selectOperator: true,
    //   timeOfResult: "1401/10/2",
    //   val: "0",
    // },
    // {
    //   title: "بی عنوان",
    //   description: "توضبحاتی برای اراءه نداریم جیگر",
    //   operator: "من",
    //   resultstep: false,
    //   titleAndDesc: "دتدتا",
    //   descOperator: "حالا هرچی",
    //   selectOperator: true,
    //   timeOfResult: "1401/10/2",
    //   val: "1",
    // },
  ]);
  console.log("info", info);
  const [selectedUser, setSelectedUser] = useState([]);

  useEffect(() => {
    async function LoadPage() {
      await getleads().then((data) => {
        setContent(data.leads);
        setBaseContent(data.leads);
        console.log("ss", data.leads[0].campaign_steps);
        setLoading(false);

        setstep(
          translateToReactSelect(false, data.leads[0].campaign_steps, "title")
        );
      });
    }
    LoadPage();
  }, [clewUpdater]);

  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      baseContent.map((val) => {
        return {
          ...val,
          customer_search: `${val.customer.firstname} ${val.customer.lastname} ${val.customer.company_name}`,
          mainUid_search: `${val.main_uid.fullname}`,
          campaign_search: `${val.campaign.title} `,
          product_services_search: `${val.product_services.title}`,
        };
      })
    );
    setContent(temp);
  }, [searchInput]);
  const selectBg = (status) => {
    // 1:actine
    // 0:delet
    switch (status) {
      case "1":
        return "blue_custom";
        break;
      case "0":
        return "secondary_custom";
        break;
    }
  };
  const returnJSX = (leadsid, campaign_id, value, last_step) => {
    return (
      <div className="d-flex justify-content-center">
        {userInfo.userRoll.includes(14) && (
          <CustomButton className="shadow-none">
            <CustomTooltip title="استپ" placement="top" color="red_custom">
              <div
                onClick={() => {
                  // getStepFun(campaign_id);

                  setStepModal(value.steps);
                  setLastStepId(last_step);
                  console.log("value.last", lastStepId);

                  setShow(true);
                }}
              >
                <StepIcon color="white"></StepIcon>
              </div>
            </CustomTooltip>
          </CustomButton>
        )}
        {userInfo.userRoll.includes(13) && (
          <CustomButton className="shadow-none">
            <CustomTooltip title="حذف" placement="top" color="red_custom">
              <div
                style={{ marginRight: "7px" }}
                onClick={() => {
                  Swal.fire({
                    title: "سرنخ مورد نظر حذف شود؟",
                    showDenyButton: true,
                    confirmButtonText: "بله",
                    denyButtonText: `خیر`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      deleteLeadsFun(leadsid);
                    }
                  });
                }}
              >
                <DeleteIcon color="white"></DeleteIcon>
              </div>
            </CustomTooltip>
          </CustomButton>
        )}
      </div>
    );
  };
  const changeHandler = (
    name,
    value,
    index,
    customerId,
    campaignId,
    action
  ) => {
    console.log("action", action);
    let temp = [...content];
    temp[index][name] = value;

    setContent(temp);
    if (action.action == "select-option") {
      changeStepFun(customerId, campaignId, value.value, temp);
      console.log("select");
    }
  };
  const returnSelect = (index, customerId, campaignId, value) => {
    let tempArray = [];
    let tagOptionArray = [{ value: "1", label: "ae" }];
    // tempArray = content[index].campaign_steps.map((v) => {
    //   return v.campaign_id;
    // });
    // tagOptionArray = step.filter((t) => tempArray.includes(t.value));
    // console.log("vcs", value.campaign_steps);
    // console.log("sss", step);
    return (
      <div style={{ color: ColorSchema.dark_custom }}>
        <ReactSelect
          itemsList={step}
          inputContainer=""
          inputSize="lg"
          inputValue={translateToReactSelect(false, [value.last_step], "title")}
          onChangeFunc={(e, action) => {
            console.log("e", e);
            console.log("action", action);

            changeHandler(
              "campaign_steps",
              e,
              index,
              customerId,
              campaignId,
              action
            );
          }}
        ></ReactSelect>
      </div>
    );
  };
  const select_name = (firstname, lastname, corporate, companiname) => {
    // 0=false
    // 1=true
    let name = "";
    name = `${firstname} ${lastname}`;
    return name;
  };
  // deletCustomrer
  async function deleteLeadsFun(leadsid) {
    await deleteLeads({
      leadId: leadsid,
    }).then((res) => {
      if (res.status == 1) {
        setClewUpdater((prev) => !prev);
        ToastCustomize({
          mainText: "سرنخ با موفقیت حذف شد",
          duration: 4000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: " مشکلی در انجام عملیات پیش آمده است   ",
          duration: 4000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  }
  // findStep
  async function getStepFun(campaign_id) {
    await getStep({ conditions: `campaign_id/=/${campaign_id}` }).then(
      (res) => {
        setInfo(res);
      }
    );
  }

  // change step
  async function changeStepFun(customerId, campaignId, stepId) {
    await changeStep({
      customerId: customerId,
      campaignId: campaignId,
      stepId: stepId,
    }).then((res) => {
      if (res.status == 1) {
        setClewUpdater((prev) => !prev);
      } else {
        ToastCustomize({
          mainText: " مشکلی در انجام عملیات پیش آمده است   ",
          duration: 4000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  }

  return (
    <div className="p-clewlist">
      {loading && <Loader></Loader>}
      <StepModal
        show={show}
        setShow={setShow}
        info={stepModal}
        setInfo={setStepModal}
        lastStepId={lastStepId}
      ></StepModal>
      {[...content].reverse()?.map((value, index) => {
        return (
          <TableCard
            column={header}
            content={{
              ...value,
              operation: returnJSX(
                value.id,
                value.campaign_id,
                value,
                value.last_step
              ),
              step: returnSelect(
                index,
                value.customer.id,
                value.campaign.id,
                value
              ),
              customerTitle: select_name(
                value.customer.firstname,
                value.customer.lastname
                // value.corporate,
                // value.company_name
              ),
              company_name: value.customer.company_name,
              title: value.campaign.title,

              starttm: value.campaign.starttm
                ? TimeStampToJalali(parseInt(value.campaign.starttm) * 1000)
                : "---",

              endtm: value.campaign.endtm
                ? TimeStampToJalali(parseInt(value.campaign.endtm) * 1000)
                : "---",
              fullname: value.main_uid.fullname,
              info: value.product_services[0]?.title,
            }}
            bg={selectBg(value.status)}
            widthParent={"90%"}
            showSelect="true"
          ></TableCard>
        );
      })}
    </div>
  );
}
